<template>
    <div>
        <div class="header">
            <h1 class="postTitle">{{ this.post.title }}</h1>
            <div class="postDetails">
                <h5><i> {{ this.post.name }} </i> Book Review</h5>
                <h3> {{ this.post.date }} </h3>
            </div>
        </div>
        <div class="blog">
            <Content />
        </div>
    </div>
</template>

<style scoped>
/* https://medium.com/hackernoon/building-an-animated-sticky-header-with-custom-offset-6eb2b29d3eed */
    .blog {
        color: white;
        margin: 50px;
    }
    .header {
        margin: 0px;
        justify-content: flex-start;
        flex-direction: column;
        align-items: center;
        margin-bottom: 25px;
        border-bottom: 1px solid #B1B1B1;
        padding-bottom: 15px;
    }
    .header > img {
        width: 75px;
        align-self: center;
    }
    .postTitle {
        color: white;
        font-size: 72px;
        font-weight: 200;
        text-align: center;
        margin: 0px;
        margin-bottom: 25px;
    }
    .postDetails {
        display: flex;
        margin: 0px;
        flex-direction: row;
        width: 100%;
        justify-content: space-around;
    }
    .postDetails > h5 {
        margin: 0px;
        font-weight: 500;
        font-size: 20px;
        color: #B3B3B3;
        align-self: flex-end;
    }
    .postDetails > h3 {
        margin: 0px;
        font-size: 24px;
        color: #FFC033;
        font-weight: 300;
        text-align: right;
    }
</style>

<script>
import Posts from '@/assets/data/posts.js'
// import Content from '@/assets/blog/books/foo.md'


export default {
    data() {
        return {
            category: this.$route.query.category,
            post: Posts[this.$route.query.category][this.$route.query.post]
        }
    },
    created() {
        // import blog md file as component
        this.$options.components["Content"] = () => import('@/assets/blog/' + this.category + '/' +  this.post.content);
    },
    mounted() {
        document.documentElement.style.overflow = 'hidden';
    },
    beforeDestroy() {
        document.documentElement.style.overflow = 'auto';
    },
}
</script>